module.exports = __webpack_public_path__ + "static/media/logo.42c4f17e.png";